export const AUTH_REDIRECT_KEY = 'auth.redirect.uri'
